import { useState } from 'react';
import useLineEnv from 'hooks/useLineEnv';

function useLocalStorage(key, initialValue) {
    const { isInLiffBrowser, isInLineAppBrowser } = useLineEnv();
    const [value, setValue] = useState(() => {
        try {
            const storedValue =
                Boolean(isInLiffBrowser) && Boolean(isInLineAppBrowser)
                    ? window.localStorage[key]
                    : localStorage.getItem(key);
            if (storedValue) {
                return JSON.parse(storedValue);
            }
            return typeof initialValue === 'function' ? initialValue() : initialValue;
        } catch (error) {
            if (error.name === 'NS_ERROR_FILE_CORRUPTED') {
                // Firefox browser error: https://stackoverflow.com/questions/18877643/error-in-local-storage-ns-error-file-corrupted-firefox
                console.error('Firefox storage has been corrupted when get local storage', error);
                return typeof initialValue === 'function' ? initialValue() : initialValue;
            } else {
                console.error('Failed to get local storage', error);
                return typeof initialValue === 'function' ? initialValue() : initialValue;
            }
        }
    });

    function setItem(value) {
        setValue(prevValue => {
            try {
                const newValue = typeof value === 'function' ? value(prevValue) : value;
                localStorage.setItem(key, JSON.stringify(newValue));
                return newValue;
            } catch (error) {
                if (error.name === 'NS_ERROR_FILE_CORRUPTED') {
                    // Firefox browser error: https://stackoverflow.com/questions/18877643/error-in-local-storage-ns-error-file-corrupted-firefox
                    console.error(
                        'Firefox storage has been corrupted when set local storage',
                        error
                    );
                } else {
                    console.error('Failed to set local storage', error);
                }
                return prevValue;
            }
        });
    }

    return [value, setItem];
}

export default useLocalStorage;
